import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=64f412ce"
import script from "./addressBook.vue?vue&type=script&lang=js"
export * from "./addressBook.vue?vue&type=script&lang=js"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=64f412ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports